import { BuildCronScheduleForModelsArgs } from './model';

export const buildCronScheduleForModels = ({
  sources,
  model,
}: BuildCronScheduleForModelsArgs): string => {
  const source = sources?.find((source) =>
    model.compatiblePreconfiguredSources.includes(
      source?.preconfiguredSourceName as string
    )
  );

  if (!source) {
    return '';
  }

  return source.schedule;
};
